import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import instructions from './instructions'
import users from './users'
import apiLoading from './apiLoading'
import routes from './routes'
import databases from './databases'
import notifications from './notifications'
import error from './error'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    instructions,
    users,
    apiLoading,
    routes,
    databases,
    notifications,
    error
  }
})